import {connect} from 'react-redux';
import React, {Component} from 'react';
import Navigation from '../../components/Navigation/Navigation';
import utils from '../../utils/utils';
import {fetchPosts, search, datePickerDatesRange} from './../../actions';

class NavigationController extends Component {
  render() {
    return (
      <Navigation {...this.props}/>
    );
  }
}

let searchText = '';
let tag = '';

function updateSearchText(e) {
  searchText = e.target.value;
}

function isActive(path) {
  return `/${tag}` === path;
}

function searchPosts() {
  if (searchText.trim().length === 0) {
    return () => {};
  }

  utils.reportBi('333', `search_term=${searchText}`);
  return fetchPosts({
    filter: searchText,
    tag: tag !== '' ? tag : 'main',
    baseURL: window.basePath,
    basename: window.relPath
  });
}

function mapStateToProps(state) {
  tag = state.posts.tag;
  return {
    isActive,
    updateSearchText,
    tag: state.posts.tag,
    searchPosts,
    activeExperiments: state.experiments.active,
    locale: state.locale.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPosts: params => {
      return dispatch(searchPosts(params));
    },
    search: params => dispatch(search(params)),
    datePickerDatesRange: () => dispatch(datePickerDatesRange([]))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationController);



// WEBPACK FOOTER //
// ./containers/Navigation/Navigation.js